export function RouteSpinner() {
  return (
    <div className="flex h-screen items-center justify-center bg-[#F6F8FC]">
      <div className="h-12 w-12 animate-spin rounded-full border-b-2 border-[#2F6FED]" />
    </div>
  );
}
